import request from '../untils/request';

export const websiteNewsListApi = params => {
  return request({
    url: '/web/news/index',
    authCode: 'WEBSITE-INDEX',
    params,
  });
};

export const websiteNewsDelApi = params => {
  return request({
    url: '/web/news/delete',
    params,
  });
};

export const websiteNewsSaveApi = params => {
  return request({
    url: '/web/news/save',
    params,
  });
};

export const websiteNewsDetailApi = params => {
  return request({
    url: '/web/news/detail',
    params,
  });
};

export const websiteAppliersApi = params => {
  return request({
    url: '/web/register/index',
    authCode:'WEBSITE-INDEX',
    params,
  });
};

export const websiteApplierDetailApi = params => {
  return request({
    url: '/web/register/detail',
    params,
  });
};

export const websiteApplierUpdateApi = params => {
  return request({
    url: '/web/register/update',
    params,
  });
};

export const websiteApplierDeleteApi = params => {
  return request({
    url: '/web/register/delete',
    params,
  });
};
